/*BizDev*/
if (window.location.pathname.includes('bizdev-dashboard')) {
    // Date range picker
    let range_start_date = $('#startDatePicker').val();
    let range_end_date = $('#endDatePicker').val();

    $('.alert-datepicker').datepicker({
        uiLibrary: 'bootstrap4',
        minDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()),
    });

    $('#startDatePicker').datepicker({
        uiLibrary: 'bootstrap4',
        iconsLibrary: 'fontawesome',
        maxDate: function () {
            return $('#endDatePicker').val();
        },
        open: function () {
            $('#startDatePicker').closest('.form-daterangepicker').addClass('active');
        },
        close: function () {
            $('#startDatePicker').closest('.form-daterangepicker').removeClass('active');
        },
        change: function (e) {
            if (range_start_date !== e.currentTarget.value) {
                range_start_date = e.currentTarget.value;
                window.app_methods.getAlerts({
                    start_date: range_start_date,
                    end_date: range_end_date
                });
            }
        }
    });

    $('#endDatePicker').datepicker({
        uiLibrary: 'bootstrap4',
        iconsLibrary: 'fontawesome',
        minDate: function () {
            return $('#startDatePicker').val();
        },
        open: function () {
            $('#endDatePicker').closest('.form-daterangepicker').addClass('active');
        },
        close: function () {
            $('#endDatePicker').closest('.form-daterangepicker').removeClass('active');
        },
        change: function (e) {
            if (range_end_date !== e.currentTarget.value) {
                range_end_date = e.currentTarget.value;
                window.app_methods.getAlerts({
                    start_date: range_start_date,
                    end_date: range_end_date
                });
            }
        }
    });

    $('.form-control-date-custom').on('click', function () {
        $(this).closest('.form-control-wrap').find('input').trigger('focus');
    });

    $(window).on("popup_close", function(e, popover, confirm){
        $(".update-alert").popover("hide");
        $(".complete-alert").popover("hide");
        $(".delete-alert").popover("hide");
    });

    $(window).on("confirm.bs.popover", function(e, popover, confirm){
        var ele = $(popover.element);
        if(confirm && ele.hasClass("complete-alert")) {
            window.app_methods.completeAlert(ele.hasClass("skip-log"));
        } else if(confirm && ele.hasClass("update-alert")) {
            window.app_methods.updateAlert(ele.hasClass("skip-log"));
        } else if(confirm && ele.hasClass("delete-alert")) {
            window.app_methods.deleteAlert();
        }
        ele.popover("dispose");
    });

    $(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
        window.app_data.calendarKeys++;
        window.app_data.activeTabId = $(this).attr('aria-controls');
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/bizdev.js